import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const requestBsUpload = async (path: string, data: object) => {
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `bs-service/${path}`,
        method: "post",
        data,
        timeout: 90000,
    });
    return res;
};
